<template>
    <div id="loader-wrapper" style="position: relative; width: unset; height: unset; top: unset; left: unset; min-height: 150px;">
        <div id="loader" class="content_animate_2">
            <div>
                <div class="loader-spin"></div>
                <div class="img_line"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoaderWrapper',
}
</script>
